export const NavModule = {
    state: {
        show: false,
        overlay: false,
    },
    mutations: {
        changeActive(state) {
            state.show = !state.show;
            state.overlay = !state.overlay;
        },
        closeSidebar(state) {
            state.show = false;
            state.overlay = false;
        },
    },
    namespaced: true,
};
